export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const guarded = async (fn, onAuthError) => {
  try {
    return await fn();
  } catch (e) {
    if (e.response?.status === 401 || e.response?.status === 403) {
      onAuthError();
      return undefined;
    }
    throw e;
  }
};

export const LEAD_STAGES = ["new", "contacted", "meeting", "proposal", "won", "lost"];
export const TICKET_STATUSES = ["open", "in_progress", "resolved", "closed"];
export const PRIORITIES = ["low", "medium", "high", "urgent"];
export const SCHOOL_STAGES = ["pool", "survey", "installation", "training", "live"];
export const OFFICES = ["Tema office", "Abidjan office"];
export const TOPICS = [
  "Abidjan office",
  "Tema office",
  "General tech support",
  "Bureau d'Abidjan",
  "Bureau de Tema",
  "Support technique général",
];
export const TEAM = ["William K. Goeh", "Marilyn Quist", "Andrea Asare", "Victor Sippire"];

export const label = (s) => String(s || "").replace(/_/g, " ");

export const chipCls = (s) =>
  ({
    new: "bg-[#581820]/10 text-[#581820]",
    contacted: "bg-[#B45309]/10 text-[#B45309]",
    meeting: "bg-[#1230AE]/10 text-[#1230AE]",
    proposal: "bg-[#2D4A3E]/10 text-[#2D4A3E]",
    won: "bg-[#1E7A5A]/10 text-[#1E7A5A]",
    lost: "bg-[#8A837B]/15 text-[#6B655F]",
    open: "bg-[#581820]/10 text-[#581820]",
    in_progress: "bg-[#B45309]/10 text-[#B45309]",
    resolved: "bg-[#1E7A5A]/10 text-[#1E7A5A]",
    closed: "bg-[#8A837B]/15 text-[#6B655F]",
    low: "bg-[#8A837B]/15 text-[#6B655F]",
    medium: "bg-[#1230AE]/10 text-[#1230AE]",
    high: "bg-[#B45309]/10 text-[#B45309]",
    urgent: "bg-[#581820]/10 text-[#581820]",
    pool: "bg-[#8A837B]/15 text-[#6B655F]",
    survey: "bg-[#B45309]/10 text-[#B45309]",
    installation: "bg-[#1230AE]/10 text-[#1230AE]",
    training: "bg-[#2D4A3E]/10 text-[#2D4A3E]",
    live: "bg-[#1E7A5A]/10 text-[#1E7A5A]",
  })[s] || "bg-[#8A837B]/15 text-[#6B655F]";

export const inputCls =
  "w-full border-b border-[#DCD6CE] bg-transparent px-0 py-2 text-sm text-[#141210] placeholder:text-[#8A837B] focus:border-[#581820] focus:outline-none transition-colors duration-300";

export const selectCls =
  "border border-[#E6E2DC] bg-white px-2 py-1.5 text-xs font-semibold text-[#141210] focus:border-[#581820] focus:outline-none cursor-pointer";

export const btnPrimary =
  "inline-flex items-center gap-2 bg-[#141210] px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.15em] text-[#FAF8F5] transition-colors duration-300 hover:bg-[#581820] disabled:opacity-60";

export const btnGhost =
  "inline-flex items-center gap-2 border border-[#DCD6CE] px-4 py-2 text-[11px] font-bold uppercase tracking-[0.15em] text-[#141210] transition-colors duration-300 hover:border-[#581820] hover:text-[#581820]";
